import React from "react";

import { Permissions } from "./auth/permissions";

// Admin Imports
import HomePage from "./pages/admin/home";
import Profile from "./pages/admin/profile";

import TimeSheetManagement from "./pages/admin/timeSheet";
import UserManagement from "./pages/admin/users";
import DirectoryPage from "./pages/admin/directory";
import ClientsManagement from "./pages/admin/clients";
import ProjectManagement from "./pages/admin/project";
import ProjectTasksPage from "./pages/admin/projectTasks";
import CapacityPage from "./pages/admin/capacity";
import ClientPortalPage from "./pages/admin/clientPortal";
import TicketsPage from "./pages/admin/tickets";
import TeamManagement from "./pages/admin/team";
import HoursManagement from "./pages/admin/hoursManagement";

// Auth Imports

// Icon Imports
import {
  MdHome,
  MdBarChart,
  MdPerson,
  MdAvTimer,
  MdLock,
  MdAttachMoney,
  MdChecklist,
  MdSpeed,
  MdStorefront,
  MdSettings,
  MdAutoAwesome,
  MdVpnKey,
  MdMenuBook,
  MdManageAccounts,
  MdAccountTree,
  MdWallpaper,
  MdCampaign,
  MdConfirmationNumber,
  MdBadge,
  // MdHome,
  MdPeople,
  MdInsertChart,
} from "react-icons/md";
import { BiSolidReport } from "react-icons/bi";
import { FaComputer } from "react-icons/fa6";
import { LuBuilding2 } from "react-icons/lu";
import { GrProjects, GrUserSettings } from "react-icons/gr";
import { FaUsersGear } from "react-icons/fa6";
import { FiShield } from "react-icons/fi";
import { LiaBusinessTimeSolid } from "react-icons/lia";
import SignIn from "./pages/auth/SignIn";
import ChangeTemporaryPassword from "./pages/auth/ChangeTemporaryPassword";
import EsqueciSenha from "./pages/auth/EsqueciSenha";
import DefinirSenha from "./pages/auth/DefinirSenha";
import Reports from "./pages/admin/report";
import ResetPassword from "./pages/admin/auth/ResetPassword";
import EquipamentManagement from "./pages/admin/equipamentManagement";
import ProfilesPage from "./pages/admin/profiles";
import PessoasPage from "./pages/admin/pessoas";
import AcessosPage from "./pages/admin/acessos";
import FinancialManagement from "./pages/admin/financial";
import ApiKeysPage from "./pages/admin/apiKeys";
import ApiDocsPage from "./pages/admin/apiDocs";
import SettingsPage from "./pages/admin/settings";
import DesignSystemPage from "./pages/admin/designSystem";
import Organograma from "./pages/admin/organograma";
import WallpaperPage from "./pages/admin/wallpaper";
import NewsPage from "./pages/admin/news";
import PaineisPage from "./pages/admin/paineis";
// Lazy: o `powerbi-client` não carrega no jsdom e as suítes que importam `routes.tsx` quebrariam.
const PainelVisualizador = React.lazy(() => import("./pages/admin/paineis/visualizador"));
const PaineisAdminPage = React.lazy(() => import("./pages/admin/paineis-admin"));

const routes = [
  {
    // Primeiro item da sidebar e destino de todo login interno (ver utils/homeRoute.ts).
    // Inclui Finance de propósito: era o único papel sem ponto de entrada no portal.
    name: "Início",
    layout: "/admin",
    path: "home",
    permission: Permissions.DashboardView,
    icon: <MdHome className="h-6 w-6" />,
    component: <HomePage />,
  },
  {
    // Logo abaixo da Home de propósito: comunicado que mora no fim do menu não é lido.
    name: "Opera/Data News",
    layout: "/admin",
    path: "news",
    permission: Permissions.NewsView,
    icon: <MdCampaign className="h-6 w-6" />,
    component: <NewsPage />,
  },
  {
    name: "Portal do Cliente",
    layout: "/admin",
    path: "client-portal",
    permission: Permissions.ClientPortalView,
    icon: <MdStorefront className="h-6 w-6" />,
    component: <ClientPortalPage />,
  },
  {
    name: "Chamados",
    layout: "/admin",
    path: "tickets",
    permission: Permissions.TicketsView,
    icon: <MdConfirmationNumber className="h-6 w-6" />,
    component: <TicketsPage />,
  },
  {
    name: "Perfil",
    layout: "/admin",
    path: "profile",
    permission: Permissions.EmployeesViewSelf,
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "Redefinir senha",
    layout: "/admin",
    path: "reset-password",
    icon: <MdLock className="h-6 w-6" />,
    permission: Permissions.EmployeesViewSelf,
    component: <ResetPassword />,
  },
  {
    name: "Timesheet",
    layout: "/admin",
    path: "timesheet",
    permission: Permissions.TimesheetView,
    icon: <MdAvTimer className="h-6 w-6" />,
    component: <TimeSheetManagement />,
  },

  {
    name: "Usuários",
    layout: "/admin",
    path: "users-management",
    permission: Permissions.EmployeesManage,
    group: "Cadastros",
    icon: <GrUserSettings className="h-6 w-6" />,
    component: <UserManagement />,
  },
  {
    name: "Diretório",
    layout: "/admin",
    path: "directory",
    permission: Permissions.EmployeesManage,
    group: "Cadastros",
    icon: <MdBadge className="h-6 w-6" />,
    component: <DirectoryPage />,
  },
  {
    name: "Clientes",
    layout: "/admin",
    path: "clients-management",
    permission: Permissions.ClientsView,
    group: "Cadastros",
    icon: <LuBuilding2 className="h-6 w-6" />,
    component: <ClientsManagement />,
  },
  {
    /*
      Substitui a antiga tela "Papéis". Ela criava papéis do Identity que, depois da migração para
      permissões, não são citados por nenhum `[Authorize]` — criar um ali virou gesto sem efeito.
      Papel segue existindo para escopo por LINHA ("meus clientes") e continua sendo atribuído na
      tela de Usuários; o que saiu foi o CRUD de papéis, não o conceito.
    */
    name: "Perfis de acesso",
    layout: "/admin",
    path: "profiles",
    permission: Permissions.ProfilesManage,
    group: "Cadastros",
    icon: <FiShield className="h-6 w-6" />,
    component: <ProfilesPage />,
  },
  {
    name: "Pessoas",
    layout: "/admin",
    path: "pessoas",
    permission: Permissions.IdentidadeAdmin,
    group: "Cadastros",
    icon: <MdPeople className="h-6 w-6" />,
    component: <PessoasPage />,
  },
  {
    name: "Painéis",
    layout: "/admin",
    path: "paineis-admin",
    permission: Permissions.BiTenantManage,
    group: "Cadastros",
    icon: <MdInsertChart className="h-6 w-6" />,
    component: (
      <React.Suspense
        fallback={<div className="mt-5 h-[320px] animate-pulse rounded-[20px] bg-gray-100 dark:bg-navy-800" aria-busy="true" />}
      >
        <PaineisAdminPage />
      </React.Suspense>
    ),
  },
  {
    name: "API Keys",
    layout: "/admin",
    path: "api-keys",
    permission: Permissions.IntegrationManage,
    group: "Cadastros",
    icon: <MdVpnKey className="h-6 w-6" />,
    component: <ApiKeysPage />,
  },
  {
    name: "API do NINA",
    layout: "/admin",
    path: "api-docs",
    permission: Permissions.IntegrationView,
    group: "Cadastros",
    icon: <MdMenuBook className="h-6 w-6" />,
    component: <ApiDocsPage />,
  },
  {
    name: "Projetos",
    layout: "/admin",
    path: "project-management",
    permission: Permissions.ProjectsManage,
    group: "Cadastros",
    icon: <GrProjects className="h-6 w-6" />,
    component: <ProjectManagement />,
  },
  {
    name: "Tarefas",
    layout: "/admin",
    path: "project-tasks",
    permission: Permissions.TasksManage,
    icon: <MdChecklist className="h-6 w-6" />,
    component: <ProjectTasksPage />,
  },
  {
    name: "Capacity",
    layout: "/admin",
    path: "capacity",
    permission: Permissions.CapacityView,
    icon: <MdSpeed className="h-6 w-6" />,
    component: <CapacityPage />,
  },
  {
    name: "Organograma",
    layout: "/admin",
    path: "organograma",
    permission: Permissions.OrgView,
    group: "Cadastros",
    icon: <MdAccountTree className="h-6 w-6" />,
    component: <Organograma />,
  },
  {
    name: "Papel de parede",
    layout: "/admin",
    path: "wallpaper",
    permission: Permissions.WallpaperManage,
    group: "Cadastros",
    icon: <MdWallpaper className="h-6 w-6" />,
    component: <WallpaperPage />,
  },
  {
    name: "Equipe",
    layout: "/admin",
    path: "team-management",
    permission: Permissions.ClientProjectsManage,
    group: "Cadastros",
    icon: <FaUsersGear className="h-6 w-6" />,
    component: <TeamManagement />,
  },
  {
    name: "Horas",
    layout: "/admin",
    path: "hours-management",
    permission: Permissions.TimesheetManage,
    icon: <LiaBusinessTimeSolid className="h-6 w-6" />,
    component: <HoursManagement />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Trocar senha temporária",
    layout: "/auth",
    path: "change-temporary-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <ChangeTemporaryPassword />,
  },
  {
    name: "Esqueci minha senha",
    layout: "/auth",
    path: "esqueci",
    icon: <MdLock className="h-6 w-6" />,
    component: <EsqueciSenha />,
  },
  {
    name: "Definir senha",
    layout: "/auth",
    path: "definir-senha",
    icon: <MdLock className="h-6 w-6" />,
    component: <DefinirSenha />,
  },
  {
    name: "Relatórios",
    layout: "/admin",
    path: "reports",
    permission: Permissions.ReportsView,
    icon: <BiSolidReport className="h-6 w-6" />,
    component: <Reports />,
  },
  {
    name: "Equipamentos",
    layout: "/admin",
    path: "equipamentManagement",
    permission: Permissions.EquipmentManage,
    group: "Cadastros",
    icon: <FaComputer className="h-6 w-6" />,
    component: <EquipamentManagement/>
  },
  {
    // Último item de "Cadastros": quem administra pessoas de uma organização cliente.
    // `identidade.admin` age em qualquer uma; `org.people.manage` só na própria (o backend decide).
    name: "Acessos",
    layout: "/admin",
    path: "acessos",
    permission: [Permissions.IdentidadeAdmin, Permissions.OrgPeopleManage],
    group: "Cadastros",
    icon: <MdManageAccounts className="h-6 w-6" />,
    component: <AcessosPage />,
  },
  {
    name: "Painéis",
    layout: "/admin",
    path: "paineis",
    permission: Permissions.BiView,
    icon: <MdBarChart className="h-6 w-6" />,
    component: <PaineisPage />,
  },
  {
    name: "Painel",
    layout: "/admin",
    path: "paineis/:id",
    permission: Permissions.BiView,
    icon: <MdBarChart className="h-6 w-6" />,
    component: (
      <React.Suspense
        fallback={<div className="mt-5 h-[320px] animate-pulse rounded-[20px] bg-gray-100 dark:bg-navy-800" aria-busy="true" />}
      >
        <PainelVisualizador />
      </React.Suspense>
    ),
  },
  {
    name: "Financeiro",
    layout: "/admin",
    path: "financial",
    permission: Permissions.FinancialView,
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <FinancialManagement />,
  },
  {
    name: "Configurações",
    layout: "/admin",
    path: "settings",
    permission: Permissions.GoalsManage,
    icon: <MdSettings className="h-6 w-6" />,
    component: <SettingsPage />,
  },
  {
    name: "Design System",
    layout: "/admin",
    path: "design-system",
    permission: Permissions.DesignSystemView,
    icon: <MdAutoAwesome className="h-6 w-6" />,
    component: <DesignSystemPage />,
  },
];
export default routes;
